import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const dashboardLastVisitedRoute: InvariantJiraRoute = {
	name: 'dashboard-last-visited',
	path: '/jira/dashboards/last-visited',
	query: ['maximized?'],
	exact: true,
};
